import React from "react";
import { BoxIcon } from "lucide-react";
interface FormSectionProps {
  icon: BoxIcon;
  title: string;
  description?: string;
  children: React.ReactNode;
}

/** Bloque destacado del formulario: borde neón y título grande. */
export function FormSection({
  icon: Icon,
  title,
  description,
  children
}: FormSectionProps) {
  return <fieldset className="rounded-2xl border border-neon/50 bg-neon/[0.04] p-5 shadow-neon sm:p-6" data-id="element-305" data-mp="3og8t90s8hzio">
      <legend className="sr-only" data-id="element-306" data-mp="3td7lfdsc7we8">{title}</legend>
      <div className="mb-5 flex items-start gap-3" data-id="element-307" data-mp="19onnlnp4327">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-neon text-ink shadow-neon-btn" data-id="element-308" data-mp="1855tqme5jyb">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-309" data-mp="678edl1ky8b1" />
        </span>
        <div data-id="element-310" data-mp="b7mcobddq3vv">
          <h3 className="font-display text-xl font-semibold leading-tight text-white sm:text-2xl" data-id="element-311" data-mp="b61pj6te9n81">{title}</h3>
          {description && <p className="mt-1 text-sm text-muted" data-id="element-312" data-mp="2cz94ug90c4tx">{description}</p>}
        </div>
      </div>
      {children}
    </fieldset>;
}